import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "currentcolor",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("path", { d: "m26.235 49.165 6.753 8.775 20.154-15.502-6.754-8.775zM61.462 29.054a5.54 5.54 0 0 0-7.765-1.013l-4.384 3.372 6.754 8.775 4.382-3.37a5.536 5.536 0 0 0 1.013-7.764M22.395 52.119c-1.074.824-2.372 2.525-2.888 3.775l-2.804 6.81c-.259.628.078 1.065.751.976l7.302-.963c1.342-.176 3.317-.996 4.39-1.822l.916-.703-6.753-8.776zM7.948 28.528v-3.734c0-.526.426-.952.952-.952h22.524c.526 0 .952.426.952.952v3.734a.95.95 0 0 1-.952.952H8.9a.95.95 0 0 1-.952-.952m0-16.337c0-.535.434-.97.969-.97h35.267c.536 0 .969.435.969.97v3.7a.97.97 0 0 1-.969.968H8.917a.97.97 0 0 1-.969-.969zm43.62 12.666V2.303c0-.981-.796-1.777-1.777-1.777H3.777C2.796.526 2 1.322 2 2.303v46.014c0 .981.796 1.777 1.777 1.777h14.515z" })
    ], -1)
  ]))]))
}
export default { render: render }